import { jsx as _jsx } from "react/jsx-runtime";

function MetaDescription({
  content
}) {
  return /*#__PURE__*/_jsx("meta", {
    name: "description",
    content: content,
    "data-test-id": "description"
  });
}

export default MetaDescription;